import axios from 'axios';

const api = axios.create({
  // Thay vì localhost, trỏ thẳng lên Render
  baseURL: 'https://ctg-backend-v2.onrender.com/api', 
});

export default api;